import React from 'react';
import classNames from 'classnames';

export type UltraStatPickerOption = {
  key: string;
  label: string;
  value: string | number;
};

type Props = {
  slotIndex: number;
  options: UltraStatPickerOption[];
  currentKey: string | null;
  onSelect: (key: string) => void;
  onClear: () => void;
  onClose: () => void;
};

const V2UltraStatPicker: React.FC<Props> = ({
  slotIndex,
  options,
  currentKey,
  onSelect,
  onClear,
  onClose,
}) => {
  const [query, setQuery] = React.useState('');
  const searchRef = React.useRef<HTMLInputElement>(null);

  React.useEffect(() => {
    searchRef.current?.focus();
  }, [slotIndex]);

  React.useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [onClose]);

  const normalizedQuery = query.trim().toLowerCase();
  const filteredOptions = normalizedQuery
    ? options.filter((option) => option.label.toLowerCase().includes(normalizedQuery))
    : options;

  return (
    <section className="portable-ultra-stat-picker" aria-label="Выбор стата">
      <div className="portable-ultra-stat-picker__head">
        <p className="portable-ultra-stat-picker__title">Ячейка {slotIndex + 1}</p>
        <button
          type="button"
          className="portable-ultra-chip portable-ultra-chip--tiny"
          onClick={onClose}
        >
          Закрыть
        </button>
      </div>
      <input
        ref={searchRef}
        type="search"
        className="portable-ultra-field portable-ultra-stat-picker__search"
        placeholder="Поиск стата…"
        value={query}
        onChange={(event) => setQuery(event.target.value)}
      />
      <ul className="portable-ultra-stat-picker__list" role="listbox" aria-label="Список статов">
        {filteredOptions.length === 0 ? (
          <li className="portable-ultra-stat-picker__empty">Ничего не найдено</li>
        ) : (
          filteredOptions.map((option) => (
            <li key={option.key}>
              <button
                type="button"
                role="option"
                aria-selected={currentKey === option.key}
                className={classNames(
                  'portable-ultra-stat-picker__option',
                  currentKey === option.key && 'portable-ultra-stat-picker__option--active',
                )}
                onClick={() => onSelect(option.key)}
              >
                <span className="portable-ultra-stat-picker__option-label">{option.label}</span>
                <span className="portable-ultra-stat-picker__option-value">{option.value}</span>
              </button>
            </li>
          ))
        )}
      </ul>
      {currentKey ? (
        <button
          type="button"
          className="portable-ultra-chip portable-ultra-chip--danger"
          onClick={onClear}
        >
          Очистить ячейку
        </button>
      ) : null}
    </section>
  );
};

export default V2UltraStatPicker;
